<app-dialog-base [showLoadingSpinner]="uiState == uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Deactivate Strips</span>
  <ng-container dialog-content>
    @if (activeNumbers.length > 0) {
        <table mat-table [dataSource]="activeStripsDataSource">

          <!-- Checkbox Column -->
          <ng-container matColumnDef="Select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selectedStripsForDeactivation.hasValue() && isAllSelected()"
                            [indeterminate]="selectedStripsForDeactivation.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selectedStripsForDeactivation.toggle(row) : null"
                            [checked]="selectedStripsForDeactivation.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="Id">
            <th mat-header-cell *matHeaderCellDef> Gold Rush Strip Id</th>
            <td data-testid="gold-rush-strip-number" mat-cell *matCellDef="let element"> {{ element.Id }}</td>
          </ng-container>

          <ng-container matColumnDef="TicketNumbers">
            <th mat-header-cell *matHeaderCellDef> Ticket Numbers</th>
            <td mat-cell *matCellDef="let element"> {{ getNumbersString(element.TicketNumbers) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              (click)="selectedStripsForDeactivation.toggle(row)">
          </tr>
        </table>
    } @else {
      <p class="red-text">looks like the user does not have active strips to deactivate</p>
    }


  </ng-container>
  <ng-container actions>
    <button
      data-testid="deactivate-player-numbers-button"
      mat-button
      (click)="deactivateNumbers()"
      [disabled]="uiState == uiStateEnumForTemplate.ShowLoading">
      Deactivate Strips
    </button>
  </ng-container>
</app-dialog-base>
